const STAFF_ROLES = new Set(["admin", "superadmin", "tutor"]);

export function hasTutoringToolsAccess(user, entitlements) {
  const role = String(user?.role || "").toLowerCase().trim();
  if (STAFF_ROLES.has(role)) return true;
  return role === "student" && entitlements?.tutoringIncluded === true;
}

